import styles from "./DisplayAsset.module.css";
import downloadFile from "../../services/DownloadFile";
import DeleteModal from "../DeleteView/DeleteModal";
import React from "react";
import ElementsContextType from "../../types/ElementsContextType";
import { ElementsContext } from "../contexts/ElementsContext";
import { useSelector } from "react-redux";
import ReactGA from "react-ga4";

interface IDictionary {
    [index: string]: string;
}

//TODO: ideally we should = use the asset type to drive the look feel and have one display component or move the style out the class and pass it in.
const cardStyleList = {
    small: styles.smallCard,
    medium: styles.mediumCard
} as IDictionary;

const documentStyleList = {
    medium: styles.mediumCheckList
} as IDictionary;

const filenameStyleList = {
    small: styles.smallFilename,
    medium: styles.mediumFilename
} as IDictionary;

export default function DisplayAsset(props: any) {
    const [showDeleteModal, setShowDeleteModal] = React.useState(false);
    const { openImageViewer } = React.useContext(
        ElementsContext
    ) as ElementsContextType;
    const checklistComplete: boolean = useSelector(
        (state: any) =>
            state.portal.activeInspection.SurveyorCompletionStatus
                .ChecklistComplete
    );
    const deleteSvg: string = checklistComplete
        ? "/images/Roll-Over-Delete-Disable.svg"
        : "/images/Roll-Over-Delete.svg";
    const cursorStyle: string = checklistComplete ? "default" : "pointer";

    function onDownload(onClickEvent: any) {
        downloadFile(props.asset.url, props.asset.name);
        ReactGA.event({
            category: "Asset Download",
            action: "download",
            label: props.asset.name,
            value: 0
        });
        onClickEvent.stopPropagation();
    }

    function onDelete(onClickEvent: any) {
        if (!checklistComplete) {
            setShowDeleteModal(true);
        }
        onClickEvent.stopPropagation();
    }

    function onView(onClickEvent: any) {
        openImageViewer(props.asset, props.element);
        onClickEvent.stopPropagation();
    }

    return (
        <div>
            <DeleteModal
                elementId={props.element.Id}
                asset={props.asset}
                active={showDeleteModal}
                closeModal={() => {
                    setShowDeleteModal(false);
                }}
            />
            <div className={cardStyleList[props.displayStyle]}>
                <div
                    onClick={props.clickHandler}
                    className={documentStyleList[props.displayStyle]}
                    style={{ backgroundImage: `url(/images/document.svg)` }}
                />
                <div
                    className={styles.deleteIcon}
                    style={{ cursor: cursorStyle }}
                >
                    <a target="_blank" rel="noreferrer" onClick={onDelete}>
                        <img alt={"delete asset"} src={deleteSvg} />
                    </a>
                </div>
                <div className={styles.viewIcon}>
                    <a target="_blank" rel="noreferrer" onClick={onView}>
                        <img
                            alt={"view asset"}
                            src="/images/Roll-Over-View.svg"
                        />
                    </a>
                </div>
                <div className={styles.downloadIcon}>
                    <a target="_blank" rel="noreferrer" onClick={onDownload}>
                        <img
                            alt={"download asset"}
                            src="/images/Roll-Over-Download.svg"
                        />
                    </a>
                </div>
                <p className={filenameStyleList[props.displayStyle]}>
                    {props.asset.name}
                </p>
            </div>
        </div>
    );
}
